import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { SidebarWrapperContent } from '@/components/atoms/SidebarWrapper/SidebarWrapper';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';

import { RuleNameValues } from './ruleFormSchema';

export const RuleNameFields = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<RuleNameValues>();

  return (
    <SidebarWrapperContent className="pb-1">
      <FormField
        control={control}
        name="name"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('field.name')}</FormLabel>
            <FormControl>
              <Input {...field} autoFocus />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name="description"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('rules.editor.description_optional')}</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </SidebarWrapperContent>
  );
};
